import { ReactComponent as FocalAlzeIcon } from '../Assets/ASightLogo.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRecoilState } from 'recoil';
import { langAtom } from '../Atom/langAtom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { Icon } from '../Components/UI/Icon';
import ProfileAvatar from '../Components/Icons/ProfileAvatar';

import itFlag from '../Assets/it.svg';
import enFlag from '../Assets/gb.svg';

import React from 'react';

export default function Navbar({ navbarItems, onLinkChange = () => { }, aziendaDettagli, urlLogo = '' }) {

  const location = useLocation();
  const [language, setLanguage] = useRecoilState(langAtom);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [settingsOpen, setSettingsOpen] = React.useState(false);
  const [shouldRenderDropdown, setShouldRenderDropdown] = React.useState(false);
  const settingsRef = React.useRef();

  React.useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('token');
    navigate('/');
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'it' ? 'en' : 'it'));
  };

  const currentFlag = language === 'it' ? itFlag : enFlag;
  const altText = language === 'it' ? 'Italiano' : 'English';

  // Dropdown visibility handler with animation delay
  React.useEffect(() => {
    if (settingsOpen) {
      setShouldRenderDropdown(true);
    } else {
      const timeout = setTimeout(() => {
        setShouldRenderDropdown(false);
      }, 200); // same as Tailwind transition duration
      return () => clearTimeout(timeout);
    }
  }, [settingsOpen]);

  // Optional: close dropdown on outside click
  React.useEffect(() => {
    const handleClickOutside = (e) => {
      if (settingsRef.current && !settingsRef.current.contains(e.target)) {
        setSettingsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);


  const settingsItems = [
    {
      label: t('changePassword'),
      icon: <Icon name='key' className="w-4 h-4" />,
      onClick: () => {
        setSettingsOpen(false);
        navigate('/change-password');
      },
    },
    {
      label: t('mfa.menuLabel', 'Sicurezza MFA'),
      icon: <Icon name='starshield' className="w-4 h-4" />,
      onClick: () => {
        setSettingsOpen(false);
        navigate('/mfa-setup');
      },
    },
    {
      label: t('logout'),
      icon: <Icon name='logout' className="w-4 h-4" />,
      onClick: () => {
        setSettingsOpen(false);
        handleLogout();
      },
      type: 'danger',
    },
  ];


  return (
    <div className="bg-[#F5F5F5] z-20">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="items-center flex justify-between">
          {/* <FocalAlzeIcon className="w-auto" /> */}
          {urlLogo && (
            <img src={urlLogo} alt="Logo" className='pl-5 py-5 w-36' />
          )}
          <div className="relative" ref={settingsRef}>
            <button
              onClick={() => setSettingsOpen(prev => !prev)}
              className="flex gap-2 items-center text-gray-700 hover:text-gray-900 transition-colors"
              aria-haspopup="menu"
              aria-expanded={settingsOpen}
            >
              <span className='font-semibold text-lg'>{aziendaDettagli?.first_name} {aziendaDettagli?.last_name}</span>
              <ProfileAvatar className={'w-7 h-7'} name={(aziendaDettagli?.first_name || '') + ' ' + (aziendaDettagli?.last_name || '')} />
            </button>

            {shouldRenderDropdown && (
              <div
                role="menu"
                className={`absolute right-0 mt-2 w-52 bg-white border border-gray-200 rounded-md shadow-lg z-30 py-1 transition-all duration-200 ease-out ${settingsOpen ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`}
              >
                {/* Nome utente */}
                <div className="px-4 py-2 font-semibold text-gray-800 text-sm">
                  {aziendaDettagli?.first_name} {aziendaDettagli?.last_name}
                </div>
                <div className="border-t my-1" />
                {settingsItems.map((item, index) => (
                  <button
                    key={index}
                    onClick={item.onClick}
                    role="menuitem"
                    className={`flex items-center gap-2 w-full text-left px-4 py-2 text-sm hover:bg-gray-100 ${item.type === 'danger' ? 'text-red-500' : 'text-gray-800'}`}
                  >
                    {item.icon && <span className="flex-shrink-0">{item.icon}</span>}
                    <span className="truncate">{item.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Navbar buttons */}
        <div className="items-center flex justify-between">

          {/* Link dinamici */}
          <div className="flex gap-4 pl-5">
            {navbarItems.map((item, index) => (
              <Link
                key={index}
                to={item.toLink}
                onClick={() => onLinkChange(item.toLink)}
                data-active={location.pathname === item.toLink}
                className="flex gap-2 items-center px-4 py-2 rounded-md shadow-sm font-medium transition-colors space-x-2 active:scale-95 
                  data-[active=true]:bg-yellow-400 data-[active=true]:text-black
                  data-[active=false]:bg-gray-200 data-[active=false]:hover:bg-gray-300 whitespace-nowrap"
              >
                {item.icon && item.icon}
                {item.label}
              </Link>
            ))}

            {/* <div className="w-[2px] h-8 bg-gray-400 self-center rounded-full"></div>

            <Link
              to="/myassets"
              data-active={location.pathname === '/myassets'}
              className="flex gap-2 items-center px-4 py-2 rounded-md shadow-sm font-medium transition-colors space-x-2 active:scale-95 
                  data-[active=true]:bg-yellow-400 data-[active=true]:text-black
                  data-[active=false]:bg-gray-200 data-[active=false]:hover:bg-gray-300 whitespace-nowrap"
            >
              {t('myAssets')}
            </Link> */}
          </div>

          {/* Spacer */}
          <div />
        </div>
      </div>

      <div className="border-b-[1px] border-[#B8B8B8] pt-4" />
    </div>
  );
}
